import { memberWorkGraph } from "@/scripts/student/midterm-viz-work.js";
import { memberTeamGraph } from "@/scripts/student/midterm-viz-team.js";

export const renderMemberGraphs = () => {
  memberWorkGraph();
  memberTeamGraph();
};
